import { z } from "zod";

export const userFormSchema = z.object({
  id: z.number(),
  name: z.string().optional().nullable(),
  username: z.string(),
  status: z.boolean().default(true),
  email: z.string().email().optional().nullable(),
  roles: z.object({
    name: z.string(),
  }),
  availableRoles: z.array(z.string()),
  password: z.string().optional().nullable(),
  password_confirmation: z.string().optional().nullable(),
});

export const userRelationFormSchema = z.object({
  id: z.number(),
  name: z.string().optional().nullable(),
  username: z.string(),
  status: z.boolean().default(true),
  email: z.string().email().optional().nullable(),
  roles: z.object({
    name: z.string(),
  }),
  availableRoles: z.array(z.string()),
  password: z.string(),
  password_confirmation: z.string(),
});
